import React, { useRef } from 'react';
import {
    SimpleShowLayout,
    ReferenceField,
    TextField,
    NumberField,
    DateField,
    ReferenceManyField,
    Datagrid,
    BooleanField,
    FunctionField
} from 'react-admin';
import ReactToPrint from 'react-to-print';
import Button from '@material-ui/core/Button';
import PrintIcon from '@material-ui/icons/Print';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import MultiCurrency from '../multiCurrency';

const LoanStatementTab = (props) => {
    const componentRef = useRef();

    return (
        <div>
            <div className="no-print" style={{ marginBottom: 8 }}>
                <ReactToPrint
                    trigger={() => (
                        <Button variant="outlined" color="primary" startIcon={<PrintIcon />}>
                            Print/PDF
                        </Button>
                    )}
                    content={() => componentRef.current}
                    pageStyle={''}
                />
            </div>

            <div ref={componentRef} style={{ paddingRight: 8 }}>
                   <SimpleShowLayout {...props}>
                <Typography variant="h6" gutterBottom>
                    Loan Details
                </Typography>
                
                    <ReferenceField source="employeeId" reference="employees" label="Employee" link={false}>
                        <TextField source="fullname" />
                    </ReferenceField>
                    <TextField source="type" />
                    <TextField source="name" />
                    <NumberField source="requestedAmount" />
                    <NumberField source="repayedAmount" />
                    <NumberField source="installmentAmount" />
                    <NumberField source="estimateMonths" label="Estimate Months Remaning" />
                    <TextField source="loanStatus" />
                    <DateField source="createdDate" />
                    <FunctionField
                        label="Outstanding"
                        render={(record) => {
                            const disb = (record && record.disburesedAmount) ? record.disburesedAmount : 0;
                            const rep = (record && record.repayedAmount) ? record.repayedAmount : 0;
                            return <MultiCurrency value={disb - rep} />;
                        }}
                    />
                

                <Divider style={{ margin: '16px 0' }} />

                <Typography variant="h6" gutterBottom>
                    Repayments
                </Typography>
                <ReferenceManyField
                    filter={{ oFilter: 'canceled eq false' }}
                    reference="repayments"
                    target="loans"
                    addLabel={false}
                >
                    <Datagrid rowClick={false}>
                        <DateField source="date" label="Date" />
                        <TextField source="remark" label="Remark" />
                        <BooleanField source="approved" label="Approved" />
                        <TextField source="method" label="Method" />
                        <NumberField source="principalPaid" label="Principal Paid" />
                        <NumberField source="interestPaid" label="Interest Paid" />
                        <ReferenceField source="payrollId" reference="payrolls" label="Payroll" link={false}>
                            <DateField
                                source="payrollRun.payrollDate"
                                options={{ year: 'numeric', month: 'long' }}
                            />
                        </ReferenceField>
                    </Datagrid>
                </ReferenceManyField>
                </SimpleShowLayout>
            </div>
        </div>
    );
};

export default LoanStatementTab;